export enum Gender {
  Male = 1,
  Female = 2,
}

export const Genders = [Gender.Male, Gender.Female];
